<template>
  <div class="pricing-item">
    <div>
      <span class="pricing-item-header">{{ title }}</span>

      <div class="pricing-item-price">
        {{ price }}

        <Tag
          :pricing-up="pricingUp"
          :pricing-down="pricingDown"
        >
          {{ variation }}
        </Tag>
      </div>

      <span class="pricing-item-update">Update: {{ updatedOn }}</span>
    </div>

    <!-- height: 84 - (32 - 1*2) -->
    <Trend
      :data="chartData"
      :gradient="['#0080a8']"
      :height="54"
      :width="84"
      :padding="1"
      :stroke-width="2"
      smooth
    />
  </div>
</template>

<script>
import Trend from 'vuetrend'
import {Tag} from '../Tag'

export default {
  components: {
    Trend,
    Tag,
  },

  props: {
    /**
     * Text content to place in the title
     */
    title: {
      type: String,
      required: true,
    },

    /**
     * Prive value
     */
    price: {
      type: String,
      required: true,
    },

    /**
     * Variation of the Price
     */
    variation: {
      type: String,
      required: true,
    },

    /**
     * Text content to place in the updated on.
     */
    updatedOn: {
      type: String,
      required: true,
    },

    /**
     * Applies the pricing-up shape to the component.
     */
    pricingUp: {
      type: Boolean,
      default: false,
    },

    /**
     * Applies the pricing-down shape to the component.
     */
    pricingDown: {
      type: Boolean,
      default: false,
    },

    /**
     * The data of the Trend Chart.
     */
    chartData: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>


.pricing-item {
  display: flex;
  align-items: center;

  > div {
    flex-grow: 1;
  }

  &-header {
    font-size: $font-size-base;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    margin-bottom: 1rem;
    display: block;
  }

  &-price,
  &-update {
    font-family: $font-family-monospace !important;
    display: block;
    font-size: $font-size-base * 0.75;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
  }

  &-price {
    font-weight: bold;
    margin-bottom: 0.5rem;
  }
}
</style>
